import { forwardRef } from "react";

import { Box } from "@mui/material";

import { BaseFormCounterButton, BaseFormCounterButtonProps } from "./BaseFormCounterButton";

import { FormTooltip } from "@/forms-design-system/FormTooltip";
import { mergeSx } from "@/helpers/mergeSx";
import { Add } from "@/icons/outlined";

type FormIncrementButtonProps = Omit<BaseFormCounterButtonProps, "icon"> & {
  tooltipTitle?: string;
  title?: string;
};

export const FormIncrementButton = forwardRef<HTMLButtonElement, FormIncrementButtonProps>(
  ({ sx, tooltipTitle, ...rest }, ref) => {
    const styles = mergeSx(
      {
        "&:hover .form-counter-button-rotate-icon": {
          transform: "rotate(90deg)",
        },
      },
      sx
    );

    const button = (
      <BaseFormCounterButton
        icon={<Add />}
        rippleOrigin="top-right"
        sx={styles}
        ref={ref}
        data-test="themed-increment-button"
        {...rest}
      />
    );

    if (tooltipTitle) {
      return (
        <FormTooltip title={tooltipTitle}>
          <Box>{button}</Box>
        </FormTooltip>
      );
    }

    return button;
  }
);

FormIncrementButton.displayName = "FormIncrementButton";
